export default class {
  constructor () {
    this.code = ''
    this.isLink = false
    this.label = ''
    this.value = ''
    this.isValid = false
    this.validationMessage = ''
    this.updateMessage = ''
    this.callbackMethod = null
  }
}
